/**
 * Moduł leasingu - udostępnia akcje biznesowe związane z leasingiem w KME:
 * rozpoczęcie i kontynuację wniosku.
 */
app.service('leasing', function (loading, modal, console) {
	let isBlocked = false;
	let initialized = false;
	const defaultErrorMessage = 'Wystąpiły problemy techniczne. Spróbuj ponownie później.';

	function init() {
		if (!initialized) {
			initialized = true;
			setEvents();
		}
	}

	function setEvents() {

		$('body')
			.on('click', '.js-leasing-init', function () {
				const orderNumber = $(this).data('order-number');
				if (!orderNumber) {
					throw new Error('atrybut data-order-number jest wymagany');
				}
				startLeaseApplication(orderNumber);
			})
			.on('click', '.js-leasing-continue', function () {
				const orderNumber = $(this).data('order-number');
				if (!orderNumber) {
					throw new Error('atrybut data-order-number jest wymagany');
				}
				continueLeaseApplication(orderNumber);
			});
	}

	function startLeaseApplication(orderNumber) {
		sendLeaseRequest({
			orderNumber: orderNumber,
			type: 'POST',
			url: '/leasing-application-init.ltr'
		});
	}

	function continueLeaseApplication(orderNumber) {
		sendLeaseRequest({
			orderNumber: orderNumber,
			type: 'GET',
			url: '/leasing-application-continue.ltr'
		});
	}

	function sendLeaseRequest(config) {
		if (isBlocked) {
			console.log('Akcja leasingowa jest już wykonywana');
			return;
		}

		isBlocked = true;

		if (!modal.isOpen('leasing-count')) {
			loading.start();
		}

		$.ajax({
			type: config.type,
			url: config.url,
			dataType: 'json',
			data: {
				orderNumber: config.orderNumber
			},
			success: function (response) {
				modal.close('leasing-count');
				loading.redirect(response.redirectUrl);
			},
			error: function (xhr, textStatus) {
				isBlocked = false;
				console.log('Akcja leasingowa nie udała się, status: ' + xhr.status + ', textStatus: ' + textStatus);
				showError();
			}
		});
	}

	function showError() {
		loading.stop();
		modal.close('leasing-count');
		modal.alert(defaultErrorMessage);
	}

	return {
		init
	};
});
